var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgreedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C1.79086 0 0 1.79086 0 4V16C0 18.2091 1.79086 20 4 20H16C18.2091 20 20 18.2091 20 16V4C20 1.79086 18.2091 0 16 0H4ZM17.2773 5.62924C17.6248 5.19998 17.5585 4.57028 17.1292 4.22278C16.7 3.87531 16.0703 3.94159 15.7228 4.37085L7.87654 14.0632L4.65852 11.2475C4.24288 10.8838 3.61112 10.9259 3.24744 11.3415C2.88375 11.7572 2.92587 12.3889 3.34151 12.7526L7.34151 16.2526C7.5461 16.4316 7.81477 16.5196 8.08563 16.4964C8.35649 16.4731 8.6062 16.3405 8.77726 16.1292L17.2773 5.62924Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgreedIcon);
export default __webpack_public_path__ + "static/media/agreedIcon.6170fb97b1ac1da53c25ffdaee13e4d4.svg";
export { ForwardRef as ReactComponent };